export enum UserActionIds {
  TemplafyReportDownload = 192,
  MoreLink = 193,
  LeaseCloneAndCreateNew = 194,
  LeaseAddTenancy = 195,
  LeaseViewTenancy = 196,
  LeaseAssociateTim = 197,
  LeaseDelete = 198,
  LeaseLinkAvail = 199,
  LeaseUnlinkAvail = 200,
  LeaseVerify = 201,
  AvailCloneAndCreateNew = 217,
  AvailLinkLease = 218,
  AvailUnlinkLease = 219,
  AvailDelete = 220,
  AvailVerify = 221,
  AvailMoreTakeOffMkt = 222,
  AvailTakeOffMkt = 223,
  TimCloneAndCreateNew = 253,
  TimDelete = 254,
  TimVerify = 255,
  PropCloneAndCreateNew = 233,
  PropAddAvail = 234,
  PropAddLease = 235,
  PropAddSale = 236,
  PropAddTenancy = 237,
  PropDelete = 238,
  PropVerify = 239,
  SelectComplex = 256,
  ExternalRatings = 257,
  AddCompany = 258,
  DeleteCompany = 259,
  CreateCorporateReport = 265,
  DownloadReport = 266,
  DigitalAssistant = 284,
}
